export default __webpack_public_path__ + "static/media/guido.b0d26248.Jpg";